import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { IndexAdminModel } from 'digiteq-ai-portal-client-lib';
import { Column } from '../../models/column';
import { Observable } from 'rxjs';
import { ArrayUtils } from '../../utils/array-utils';
import { DictionaryBaseModel } from '../../models/dictionary-base-model';

export interface ShowItemDialogModel {
  show: boolean;
  item?: any;
}

@Component({
  selector: 'app-crud-table',
  templateUrl: './crud-table.component.html',
  styleUrl: './crud-table.component.scss'
})
export class CrudTableComponent<T extends DictionaryBaseModel> {
  @ViewChild('dt') table?: Table;

  @Input() heading: string;
  @Input() itemTypeName?: string;
  @Input() loading: boolean = true;
  @Input() columns: Column[] = [];
  @Input() allowToggle = true;
  @Input() editObservable$?: Observable<T[]>;
  @Input() showDefaultItemBadge: boolean = true;
  @Output() showItemDialog: EventEmitter<ShowItemDialogModel> = new EventEmitter();
  @Output() add: EventEmitter<T> = new EventEmitter();
  @Output() edit: EventEmitter<T> = new EventEmitter();
  @Output() duplicate: EventEmitter<T> = new EventEmitter();
  @Output() delete: EventEmitter<T> = new EventEmitter();
  @Output() toggle: EventEmitter<T> = new EventEmitter();

  item?: IndexAdminModel;
  clonedItem: IndexAdminModel;
  deleteItemDialog: boolean = false
  search = '';

  readonly maxColCharacters = 200;

  private _items: T[] = [];
  get items(): T[] {
    return this._items;
  }

  @Input() set items(value: T[]) {
    this._items = ArrayUtils.sortByProperty(value, 'name');
  }

  onGlobalFilter(event: Event) {
    this.table?.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clearSearch() {
    (document.getElementById('search') as HTMLInputElement).value = '';
    this.table?.filterGlobal('', 'contains');
    this.search = '';
  }

  editItem(item: T) {
    if (item.id === undefined || item.id === null) {
      return;
    }
    this.clonedItem = structuredClone(item)
    this.showItemDialog.emit({show: true, item: this.clonedItem});
  }

  deleteItem(item: T) {
    this.deleteItemDialog = true;
    this.item = item;
  }

  onDeleteConfirm() {
    this.deleteItemDialog = false;
    this.delete.emit(this.item as T);
    this.item = undefined;
  }

  addItem() {
    this.showItemDialog.emit({show: true});
    this.clearSearch();
  }
}
